import { observable, action } from 'mobx';
import agent from '../../api/agent';
// import commonStore from './commonStore';

export default new class requestsStore {
    @action artworkBuyRequest(artwork_id,body) {

        return agent.Orders.artworkBuyRequest(artwork_id,body)

    }
}


// WEBPACK FOOTER //
// ./src/stores/OrdersStore/requestsStore.js